import { PageHeader } from "@shared/components/PageHeader";
import { Mail } from "lucide-react";
import React from "react";
import EmailDashboard from "../dashboard/dashboard";
import EmailList from "../list/list";

const EmailLanding = () => {
  return (
    <div>
      <div className="flex items-center gap-4">
        <Mail className="w-5 h-5 text-black" />
        <PageHeader
          title="Email Statistics"
          subtitle="Overview of email performance"
        />
      </div>
      <div className="mt-4">
        <EmailDashboard />
      </div>
      <div className="mt-4">
        <EmailList />
      </div>
    </div>
  );
};

export default EmailLanding;
